<div
  class="result-folder-container"
  (auxclick)="auxclick($event)"
  (contextmenu)="auxclick($event)"
  [ngClass]="{ selected: contextMenuActive }"
>
  <div class="folder-details">
    <u-icon [model]="FOLDER_ICON" [styles]="{ color: 'var(--light-blue-500)' }" class="folder-icon"></u-icon>
    <input-title
      *ngIf="showInputTitle; else viewTitle"
      class="folder-title folder-title-input"
      [text]="model?.title"
      [inputPlaceholder]="inputPlaceholder"
      [defaultInputModel]="defaultInputModel"
      [inputModel]="model?.title"
      (onDisplayInput)="onDisplayInput($event)"
      (onBlurUInput)="onBlurUInput($event)"
      (outsideClick)="onEditTitleClickOut()"
    >
    </input-title>
    <ng-template #viewTitle>
      <span [innerHTML]="model?.title | highlight : model.highlights : highlightStyle" class="folder-title"></span>
      <span class="folder-count">{{ model?.itemsCount || 0 }} {{ descriptionTextCount }}</span>
    </ng-template>
  </div>
  <square-button
    *ngIf="canEdit"
    [active]="contextMenuActive"
    class="square-button"
    [ngClass]="{ visible: contextMenuActive }"
    (click)="$event.stopPropagation(); openContextMenu($event)"
    (auxclick)="$event.stopPropagation(); openContextMenu($event)"
    (contextmenu)="$event.stopPropagation(); openContextMenu($event)"
    >•••</square-button
  >
</div>
